import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-crema py-16 md:py-24 px-6 lg:px-12 overflow-hidden" data-id="element-168">
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-[58%_42%] gap-12 lg:gap-8 items-center" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start" data-id="element-170">
          <div className="bg-navy/10 border border-navy rounded-full px-4 py-1.5 mb-6" data-id="element-171">
            <span className="font-sans font-bold text-navy text-[11px] uppercase tracking-[1.5px]" data-id="element-172">
              Para quien ya tiene una vida construida y no quiere quedarse atrás
            </span>
          </div>

          <h1 className="text-[34px] md:text-5xl font-serif font-bold text-navy leading-[1.15] max-w-[560px]" data-id="element-173">
            ¿Cuántas veces asentiste fingiendo entender la IA mientras algo se
            te apretaba en el pecho?
          </h1>

          <p className="text-base md:text-lg font-sans text-[#4A4A4A] leading-[1.75] max-w-[500px] mt-5" data-id="element-174">
            Este libro te devuelve la silla en la conversación que sientes que
            perdiste. Sin programar. Sin cursos técnicos. Sin jerga que nadie te
            traduce.
          </p>
          <p className="text-base md:text-lg font-sans font-medium text-[#4A4A4A] leading-[1.75] max-w-[500px] mt-3" data-id="element-175">
            Seis historias reales de personas exactamente como tú que ya están
            del otro lado.
          </p>

          <p className="text-[13px] font-sans text-gold mt-4 tracking-wide" data-id="element-176">
            121 páginas &middot; 6 historias reales &middot; PDF inmediato
            &middot; Sin tecnicismos
          </p>

          <p className="text-[12px] font-sans italic text-[#888888] mt-6" data-id="element-177">
            Precio especial de validación para los primeros 100 lectores.
          </p>

          <div className="flex items-baseline gap-3 mt-2" data-id="element-178">
            <span className="text-[22px] font-serif text-[#999999] line-through" data-id="element-179">
              $24.97
            </span>
            <span className="text-[32px] font-serif font-bold text-navy" data-id="element-180">
              $12.97
            </span>
          </div>

          <motion.a href="#offer" whileHover={{
          scale: 1.02,
          filter: 'brightness(0.92)'
        }} whileTap={{
          scale: 0.98
        }} className="mt-5 bg-burnt text-white font-sans font-bold text-[17px] rounded-lg py-[18px] px-[44px] shadow-[0_4px_20px_rgba(230,126,34,0.35)] transition-all duration-200 w-full sm:w-auto inline-block text-center no-underline" data-id="element-181">
            Quiero entender la IA ahora &rarr;
          </motion.a>

          <p className="text-[11px] font-sans text-[#999999] mt-2.5" data-id="element-182">
            Pago único &middot; PDF inmediato &middot; Sin suscripciones
            &middot; Sin renovaciones &middot; Si no te cambia la perspectiva,
            te devolvemos el dinero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 40
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end" data-id="element-183">
          <div className="relative w-full max-w-lg" data-id="element-184">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="absolute -top-3 -right-2 md:top-0 md:right-0 z-10 bg-gradient-to-r from-[#D4AF37] to-[#C49B30] text-white font-sans font-bold text-[10px] md:text-[11px] uppercase tracking-[1px] px-4 py-2 rounded-full shadow-md" data-id="element-185">
              OFERTA DE LANZAMIENTO: 50% DCTO.
            </motion.div>
            <img src="https://cdn.magicpatterns.com/uploads/54yaqCFFJWvHdkhDYWhqbC/Imegen_Ebook_-_Marta,_Don_Raul_y_La_Inteligencia_Artificial-D.png" alt="Marta, Don Raúl y la Inteligencia Artificial - Bundle Mockup" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-186" />
          </div>
        </motion.div>
      </div>
    </section>;
}